import { toast } from 'sonner';
import i18next from '@/lib/i18n';
import { translateErrorCode } from '@/lib/errors/error-formatter';
import { isForbiddenError } from '../errors';

/** A failed request's toast — skipped for a 403, which the HTTP client already toasted (or locked the seat). */
export function toastRequestError(error: unknown, message: string) {
  if (isForbiddenError(error)) return;
  toast.error(message);
}

/**
 * Translate the backend's i18n error code when one is present (e.g.
 * errors.processDraft.publishConflict); fall back to a generic message otherwise.
 */
export function toastApiError(error: unknown, fallbackKey: string) {
  toastRequestError(error, translateErrorCode(error, fallbackKey, i18next.t));
}
